import React from "react";
import "./ProfileMembers.css";
import SSrajampouliHero from "../../../Images/SSrajamouli.webp";
import SSText from "../../../Images/SSRajamouliText.webp";

function ProfileMembers() {
  return (
    <>
      <div className="m-profiles-hero">
        <img src={SSrajampouliHero} alt="" />
      </div>

      <div className="sunilBabu">
        <div className="SunilbabuImage">
          <img src={SSText} alt="" />
        </div>
        <div className="aboutSunilBabu">
          <div className="sunilBabuText">
            <p>
              Padma Shri Koduri Srisaila Sri Rajamouli is an Indian film
              director and screenwriter and is known for his action, fantasy,
              and epic genre films. He is the highest grossing Indian director
              of all time. He is a recipient of various national and
              international honours including a New York Film Critics Circle
              award, a Critics' Choice Movie Award, two Saturn Awards, and three
              National Film Awards. In 2016, the Government of India honoured
              him with the Padma Shri, for his contributions in the field of
              Art. In 2023, he was included on Time's list of the 100 most
              influential people in the world. 'RRR', directed by SS Rajamouli,
              made history at the 2023 Oscars by winning the Best Original Song
              award for its song Naatu Naatu
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfileMembers;
